<nz-spin [nzSpinning]="loading$ | async">
  <form
    class="form"
    [formGroup]="createOwnStrategyForm"
    (ngSubmit)="createOwnStrategy()">
    <div class="drawer-form-wrapper">
      <app-student-info-card
        [student]="caseParams.case?.student"
        [supervisorName]="caseParams.case?.supervisorName">
      </app-student-info-card>
      <app-behavior-info-card
        [mode]="mode"
        [videoUrl]="strategy?.videoUrl || null"
        [behaviorCategoryName]="caseParams.behavior?.behaviorCategoryName"
        [behaviorTypes]="caseParams.behavior?.behaviorCategoryTypes">
      </app-behavior-info-card>

      <nz-form-item>
        <nz-form-label nzFor="title" nzRequired>Title</nz-form-label>
        <nz-form-control [nzErrorTip]="titleErrorTpl">
          <input
            id="title"
            type="text"
            nz-input
            formControlName="title"
            placeholder="Enter title" />
          <ng-template #titleErrorTpl let-control>
            <div *ngIf="isFieldInvalid('title')" class="error-message">
              {{ getErrorMessage('title') }}
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="description" nzRequired
          >Description</nz-form-label
        >
        <nz-form-control [nzErrorTip]="descriptionErrorTpl">
          <textarea
            id="description"
            formControlName="description"
            rows="4"
            nz-input
            placeholder="Add description"></textarea>
          <ng-template #descriptionErrorTpl let-control>
            <div *ngIf="isFieldInvalid('description')" class="error-message">
              {{ getErrorMessage('description') }}
            </div>
          </ng-template>
          <span class="hint-text">
            {{ getRemainingChars('description') }} of
            {{ MAX_LENGTHS.description }} characters used
          </span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="guidelines" formArrayName="guidelines">
        <nz-form-label>Guidelines</nz-form-label>
        <nz-form-control>
          <div
            *ngFor="let guideline of guidelinesArray.controls; let i = index"
            [formGroupName]="i">
            <nz-form-item *ngIf="!isGuidelineDeleted(i)">
              <nz-form-control>
                <textarea
                  rows="3"
                  nz-input
                  formControlName="guideline"
                  placeholder="Enter guideline"></textarea>
                <div class="input-actions">
                  <div class="display-flex guideline-actions">
                    <button
                      nz-button
                      type="button"
                      nzType="default"
                      (click)="addGuideline()"
                      *ngIf="showAddButton(i)">
                      <svg-icon
                        src="/assets/icon/icon-plus.svg"
                        class="icon s-16"
                        aria-label="Plus"></svg-icon>
                      <span class="s-14">Add Guideline</span>
                    </button>
                    <button
                      nz-button
                      type="button"
                      nzType="default"
                      (click)="removeGuideline(i)"
                      *ngIf="showDeleteButton(i)">
                      <svg-icon
                        src="/assets/icon/icon-trash.svg"
                        class="icon s-16"
                        aria-label="Trash"></svg-icon>
                      <span class="s-14">Delete Guideline</span>
                    </button>
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item *ngIf="isGuidelineDeleted(i)">
              <nz-form-control>
                <div class="deleted-guideline-notice">
                  <span>Guideline deleted</span>
                  <div class="display-flex guideline-actions">
                    <button
                      nz-button
                      type="button"
                      nzType="default"
                      (click)="undoGuideline(i)">
                      <svg-icon
                        src="/assets/icon/icon-undo.svg"
                        class="icon s-16"
                        aria-label="Undo"></svg-icon>
                      <span class="s-14">Undo Guideline</span>
                    </button>
                  </div>
                </div>
                <div
                  class="display-flex guideline-actions add-guideline-wrapper"
                  *ngIf="showAddGuidelineOnDeleted(i)">
                  <button
                    nz-button
                    type="button"
                    nzType="default"
                    (click)="addGuideline()">
                    <svg-icon
                      src="/assets/icon/icon-plus.svg"
                      class="icon s-16"
                      aria-label="Plus"></svg-icon>
                    <span class="s-14">Add Guideline</span>
                  </button>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </nz-form-control>
      </nz-form-item>

      <ng-container
        *ngIf="
          (mode === 'edit' || mode === 'guide') &&
          strategy?.behaviorStrategyDetailPrompts?.length
        ">
        <nz-form-item
          formArrayName="detailPromptAnswers"
          *ngFor="
            let prompt of strategy?.behaviorStrategyDetailPrompts;
            let i = index
          ">
          <nz-form-label nzRequired class="detail-prompt-label">
            {{ formatDetailPromptLabel(prompt.detailPrompt) }}
          </nz-form-label>
          <nz-form-control>
            <ng-container [formGroupName]="i">
              <textarea
                nz-input
                rows="4"
                formControlName="answer"
                placeholder="Add details"></textarea>
              <div class="error-message" *ngIf="isDetailPromptAnswerInvalid(i)">
                {{ getDetailPromptAnswerError(i) }}
              </div>
              <span class="hint-text">
                {{ getDetailPromptAnswerCharsUsed(i) }} of
                {{ MAX_LENGTHS.detailPromptAnswer }} characters used
              </span>
            </ng-container>
          </nz-form-control>
        </nz-form-item>
      </ng-container>

      <ng-container
        *ngIf="
          mode === 'create' ||
          (mode === 'edit' &&
            strategy?.behaviorStrategyDetailPrompts?.length === 0) ||
          (strategy?.details &&
            strategy?.behaviorStrategyDetailPrompts?.length === 0)
        ">
        <nz-form-item>
          <nz-form-label
            nzFor="details"
            [nzRequired]="mode !== 'create' && mode !== 'edit'"
            >Details</nz-form-label
          >
          <nz-form-control [nzErrorTip]="detailsErrorTpl">
            <textarea
              id="details"
              formControlName="details"
              rows="4"
              nz-input
              placeholder="Add details"></textarea>
            <ng-template #detailsErrorTpl let-control>
              <div *ngIf="isFieldInvalid('details')" class="error-message">
                {{ getErrorMessage('details') }}
              </div>
            </ng-template>
            <span class="hint-text">
              {{ getRemainingChars('details') }} of
              {{ MAX_LENGTHS.details }} characters used
            </span>
          </nz-form-control>
        </nz-form-item>
      </ng-container>

      <nz-form-item>
        <nz-form-label nzFor="notes">Note</nz-form-label>
        <nz-form-control [nzErrorTip]="notesErrorTpl">
          <textarea
            id="notes"
            formControlName="notes"
            rows="4"
            nz-input
            placeholder="Add note"></textarea>
          <ng-template #notesErrorTpl let-control>
            <div *ngIf="isFieldInvalid('notes')" class="error-message">
              {{ getErrorMessage('notes') }}
            </div>
          </ng-template>
          <span class="hint-text">
            {{ getRemainingChars('notes') }} of
            {{ MAX_LENGTHS.notes }} characters used
          </span>
        </nz-form-control>
      </nz-form-item>

      <div class="drawer-footer">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeDrawers()">
          Cancel
        </button>
        <div>
          <button
            class="create-own-strategy"
            type="button"
            nz-button
            nzType="primary"
            [disabled]="createOwnStrategyForm.invalid"
            (click)="
              mode === 'edit' || mode === 'guide'
                ? createModification()
                : saveStrategy(false)
            ">
            {{
              mode === 'edit' || mode === 'guide' ? 'Save Modification' : 'Save'
            }}
          </button>

          <button
            *ngIf="mode === 'create'"
            type="button"
            nz-button
            nzType="primary"
            [disabled]="createOwnStrategyForm.invalid"
            (click)="saveStrategy(true)">
            Save to District Records
          </button>
        </div>
      </div>
    </div>
  </form>
</nz-spin>

<!-- Delete Confirmation Modal -->
<nz-modal
  [(nzVisible)]="showDeleteConfirmModal"
  [nzTitle]="modalHeaderTemplateDelete"
  [nzFooter]="modalFooterTemplateDelete"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="cancelDeleteGuideline()">
  <ng-template #modalHeaderTemplateDelete>
    <div class="modal-header">
      <div class="modal-icon modal-icon-red">
        <svg-icon
          src="/assets/icon/icon-trash-red.svg"
          class="icon s-20"
          aria-label="Trash Red"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Delete Guideline</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Are you sure you want to delete this guideline?
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplateDelete>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="cancelDeleteGuideline()">
        Cancel
      </button>
      <button
        type="button"
        nz-button
        [nzType]="'primary'"
        class="btn btn-cancel"
        (click)="confirmDeleteGuideline()">
        Delete
      </button>
    </div>
  </ng-template>
</nz-modal>
